var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgWyshboxLogoSm = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 40,
    viewBox: "0 0 59 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4136 23.5788L9.21008 7.07102C8.8628 6.14335 7.97319 5.52966 6.98368 5.52966H0L11.27 35.51H12.759C12.9493 35.51 13.1206 35.3958 13.1967 35.2246L20.6371 17.9176C20.7227 17.7178 21.0034 17.7273 21.0795 17.9271L27.6873 35.51H29.1764C29.3666 35.51 29.5379 35.3958 29.614 35.2246L42.1019 6.19092C42.2351 5.87694 42.0067 5.5249 41.6642 5.5249H40.0562L32.2781 23.5835C32.1925 23.7833 31.9118 23.7738 31.8357 23.574L25.6322 7.07102C25.2849 6.14335 24.3953 5.52966 23.4058 5.52966H16.4221L19.7474 14.3829C19.7712 14.44 19.7665 14.5066 19.7427 14.5637L15.856 23.593C15.7704 23.7833 15.4897 23.7786 15.4136 23.5788Z",
    fill: "#1C1C1C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M56.0217 25.2629C53.5336 24.1117 51.8353 22.4181 50.6888 19.93C50.1893 18.8549 49.9419 17.8939 49.0095 17.8939C48.077 17.8939 47.8296 18.8549 47.3301 19.9348C46.1836 22.4181 44.4853 24.1164 41.9972 25.2677C40.9173 25.7672 39.9611 26.124 39.9611 26.947C39.9611 27.77 40.9173 28.1268 41.9972 28.6263C44.4853 29.7776 46.1836 31.4712 47.3301 33.9592C47.8296 35.0391 48.077 36.0001 49.0095 36.0001C49.9419 36.0001 50.1893 35.0391 50.6888 33.9592C51.8353 31.4759 53.5336 29.7776 56.0217 28.6263C57.1016 28.1268 58.0578 27.77 58.0578 26.947C58.0578 26.1192 57.1016 25.7624 56.0217 25.2629Z",
    fill: "#F37A6B"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgWyshboxLogoSm);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/wyshbox_logo_sm.e291de918de9676f9560a7e36196ec16.svg";